import {
  Box,
  Container,
  Heading,
  Text,
  Image,
  Stack,
  Button,
  SimpleGrid,
} from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import Navbar from "./Navbar";
import CodifyImage from "./images/codify1.png";
import HeroImage from "./images/stamps.png";

const CodifyDescription = () => {
  const navigate = useNavigate();

  return (
    <Box>
      <Navbar />

      {/* Background image */}
      <Image
        src={HeroImage}
        alt="Hero Watermark"
        width="100%"
        height="100%"
        objectFit="cover"
        opacity={0.30}
        position="absolute"
        top={0}
        left={0}
        zIndex={-1}
        filter="blur(1px)"
      />

      <Container maxW="container.xl" py={8}>
        <Stack spacing={8} align="stretch">
          {/* Header Section */}
          <Box
            bg="rgba(255,255,255,0.95)"
            p={12}
            borderRadius="lg"
            boxShadow="xl"
            textAlign="center"
          >
            <Image
              src={CodifyImage}
              alt="Codify"
              maxW="400px"
              mx="auto"
              mb={6}
            />
          </Box>

          {/* Main Content */}
          <Box
            bg="rgba(255,255,255,0.95)"
            p={10}
            borderRadius="lg"
            boxShadow="xl"
          >
            <Heading size="lg" mb={6} color="gray.800">
              Transform Your Policy Entry Workflow
            </Heading>

            <Text fontSize="lg" mb={6} lineHeight="1.8" color="gray.700">
              Streamline the conversion of placement information into structured data for your systems.
            </Text>

            <SimpleGrid columns={{ base: 1, md: 2 }} spacing={8} mb={8}>
              <Box>
                <Heading size="lg" color="purple.600" mb={4}>
                  BENEFIT
                </Heading>
                <Stack spacing={4}>
                  <Box p={4} bg="purple.50" borderRadius="md">
                    <Heading size="sm" color="gray.800" mb={2}>
                      Cost Reduction
                    </Heading>
                    <Stack spacing={2}>
                      <Text color="gray.700" fontSize="sm">Significant operational cost reduction through improved efficiency and productivity gains.</Text>
                    </Stack>
                  </Box>

                  <Box p={4} bg="purple.50" borderRadius="md">
                    <Heading size="sm" color="gray.800" mb={2}>
                      Reduce Rework
                    </Heading>
                  </Box>

                  <Box p={4} bg="purple.50" borderRadius="md">
                    <Heading size="sm" color="gray.800" mb={2}>
                      Data Quality Increased
                    </Heading>
                  </Box>
                </Stack>
              </Box>

              <Box>
                <Heading size="lg" color="purple.600" mb={4}>
                  FEATURES
                </Heading>
                <Stack spacing={4}>
                  <Box p={4} bg="purple.50" borderRadius="md">
                    <Heading size="sm" color="gray.800" mb={2}>
                      Data Entry Becomes A Strategic Activity
                    </Heading>
                    <Stack spacing={2}>
                      <Text color="gray.700" fontSize="sm" fontWeight="bold">Industry Standards</Text>
                      <Text color="gray.700" fontSize="sm">Built on recognized frameworks and protocols</Text>

                      <Text color="gray.700" fontSize="sm" fontWeight="bold" mt={2}>Enhanced Value</Text>
                      <Text color="gray.700" fontSize="sm">Greater output with improved efficiency</Text>

                      <Text color="gray.700" fontSize="sm" fontWeight="bold" mt={2}>Flexible Integration</Text>
                      <Text color="gray.700" fontSize="sm">Adaptable to your specific operational needs</Text>
                    </Stack>
                  </Box>

                  <Box p={4} bg="purple.50" borderRadius="md">
                    <Heading size="sm" color="gray.800" mb={2}>
                      Better Quality Jobs
                    </Heading>
                    <Text color="gray.700" fontSize="sm">
                      Reduce manual effort and elevate your team to focus on quality oversight
                    </Text>
                  </Box>
                </Stack>
              </Box>
            </SimpleGrid>

            <Box textAlign="center" mt={8}>
              <Button
                colorScheme="purple"
                size="lg"
                onClick={() => navigate("/codify")}
                boxShadow="lg"
                _hover={{ transform: "scale(1.05)" }}
                transition="all 0.2s"
              >
                Launch Codify
              </Button>
            </Box>
          </Box>

          {/* Key Features */}
          <Box
            bg="rgba(255,255,255,0.95)"
            p={10}
            borderRadius="lg"
            boxShadow="xl"
          >
            <Heading size="lg" mb={6} color="gray.800" textAlign="center">
              Codify Key Features
            </Heading>

            <SimpleGrid columns={{ base: 1, md: 2, lg: 3 }} spacing={6}>
              <Box p={4} bg="purple.50" borderRadius="md" boxShadow="md">
                <Text color="gray.700" fontSize="md">
                  Flexible information extraction
                </Text>
              </Box>

              <Box p={4} bg="purple.50" borderRadius="md" boxShadow="md">
                <Text color="gray.700" fontSize="md">
                  Multi-format support
                </Text>
              </Box>

              <Box p={4} bg="purple.50" borderRadius="md" boxShadow="md">
                <Text color="gray.700" fontSize="md">
                  Seamless integration capabilities
                </Text>
              </Box>

              <Box p={4} bg="purple.50" borderRadius="md" boxShadow="md">
                <Text color="gray.700" fontSize="md">
                  Works with other platform components
                </Text>
              </Box>

              <Box p={4} bg="purple.50" borderRadius="md" boxShadow="md">
                <Text color="gray.700" fontSize="md">
                  Participant-specific outputs
                </Text>
              </Box>

              <Box p={4} bg="purple.50" borderRadius="md" boxShadow="md">
                <Text color="gray.700" fontSize="md">
                  Independent processing workflows
                </Text>
              </Box>

              <Box p={4} bg="purple.50" borderRadius="md" boxShadow="md">
                <Text color="gray.700" fontSize="md">
                  Distributed implementation
                </Text>
              </Box>

              <Box p={4} bg="purple.50" borderRadius="md" boxShadow="md">
                <Text color="gray.700" fontSize="md">
                  Document to data transformation
                </Text>
              </Box>

              <Box p={4} bg="purple.50" borderRadius="md" boxShadow="md">
                <Text color="gray.700" fontSize="md">
                  Rapid configuration
                </Text>
              </Box>

              <Box p={4} bg="purple.50" borderRadius="md" boxShadow="md">
                <Text color="gray.700" fontSize="md">
                  Adaptable to changing requirements
                </Text>
              </Box>

              <Box p={4} bg="purple.50" borderRadius="md" boxShadow="md">
                <Text color="gray.700" fontSize="md">
                  Flexible data definitions
                </Text>
              </Box>
            </SimpleGrid>
          </Box>
        </Stack>
      </Container>
    </Box>
  );
};

export default CodifyDescription;
